import celulasmadre from "../assets/treatments/celulasmadre.webp";
import pdrn from "../assets/treatments/pdrn.webp";
import implanteplacenta from "../assets/treatments/implanteplacenta.webp";
import exososomasintravenosos from "../assets/treatments/exosomasintravenosos.webp";
import exososomasfaciales from "../assets/treatments/exosomasfaciales.webp";
import facialdeplasmaricoenplaquetas2 from "../assets/treatments/facialdeplasmaricoenplaquetas2.webp";
import hidrofacial from "../assets/treatments/hidrofacial.webp";
import celulasmadrefaciales from "../assets/treatments/celulasmadrefaciales.webp";
import nadintravenoso2 from "../assets/treatments/nadintravenoso2.webp";

export function getTratamientosData(labels) {
  return [
    {
      slug: "celulas-madre",
      age: labels["treatments.stem.age"],
      title: labels["treatments.stem.title"],
      description: labels["treatments.stem.description"],
      price: labels["treatments.stem.price"],
      aditional: [
        labels["treatments.stem.aditional.1"],
        labels["treatments.stem.aditional.2"],
        labels["treatments.stem.aditional.3"],
        labels["treatments.stem.aditional.4"],
        labels["treatments.stem.aditional.5"],
      ],
      image: celulasmadre,
    },
    {
      slug: "pdrn",
      age: labels["treatments.pdrn.age"],
      title: labels["treatments.pdrn.title"],
      description: labels["treatments.pdrn.short.description"],
      price: labels["treatments.pdrn.price"],
      aditional: [
        labels["treatments.pdrn.aditional.1"],
        labels["treatments.pdrn.aditional.2"],
        labels["treatments.pdrn.aditional.3"],
        labels["treatments.pdrn.aditional.4"],
        labels["treatments.pdrn.aditional.5"],
      ],
      image: pdrn,
    },
    {
      slug: "implante-placenta",
      age: labels["treatments.placenta.age"],
      title: labels["treatments.placenta.title"],
      description: labels["treatments.placenta.description"],
      price: labels["treatments.placenta.price"],
      aditional: [
        labels["treatments.placenta.aditional.1"],
        labels["treatments.placenta.aditional.2"],
        labels["treatments.placenta.aditional.3"],
        labels["treatments.placenta.aditional.4"],
        labels["treatments.placenta.aditional.5"],
      ],
      image: implanteplacenta,
    },
    {
      slug: "exosomas-intravenosos",
      age: labels["treatments.exosomas.age"],
      title: labels["treatments.exosomas.title"],
      description: labels["treatments.exosomas.description"],
      price: labels["treatments.exosomas.price"],
      aditional: [
        labels["treatments.exosomas.aditional.1"],
        labels["treatments.exosomas.aditional.2"],
        labels["treatments.exosomas.aditional.3"],
        labels["treatments.exosomas.aditional.4"],
        labels["treatments.exosomas.aditional.5"],
      ],
      image: exososomasintravenosos,
    },
    {
      slug: "exosomas-faciales",
      age: labels["treatments.exosomasfaciales.age"],
      title: labels["treatments.exosomasfaciales.title"],
      description: labels["treatments.exosomasfaciales.description"],
      price: labels["treatments.exosomasfaciales.price"],
      aditional: [
        labels["treatments.exosomasfaciales.aditional.1"],
        labels["treatments.exosomasfaciales.aditional.2"],
        labels["treatments.exosomasfaciales.aditional.3"],
        labels["treatments.exosomasfaciales.aditional.4"],
        labels["treatments.exosomasfaciales.aditional.5"],
      ],
      image: exososomasfaciales,
    },
    {
      slug: "plasma-rico-plaquetas",
      age: labels["treatments.plasma.age"],
      title: labels["treatments.plasma.title"],
      description: labels["treatments.plasma.description"],
      price: labels["treatments.plasma.price"],
      aditional: [
        labels["treatments.plasma.aditional.1"],
        labels["treatments.plasma.aditional.2"],
        labels["treatments.plasma.aditional.3"],
        labels["treatments.plasma.aditional.4"],
        labels["treatments.plasma.aditional.5"],
      ],
      image: facialdeplasmaricoenplaquetas2,
    },
    {
      slug: "hidrofacial",
      age: labels["treatments.hidrofacial.age"],
      title: labels["treatments.hidrofacial.title"],
      description: labels["treatments.hidrofacial.description"],
      price: labels["treatments.hidrofacial.price"],
      aditional: [
        labels["treatments.hidrofacial.aditional.1"],
        labels["treatments.hidrofacial.aditional.2"],
        labels["treatments.hidrofacial.aditional.3"],
        labels["treatments.hidrofacial.aditional.4"],
        labels["treatments.hidrofacial.aditional.5"],
      ],
      image: hidrofacial,
    },
    {
      slug: "celulas-madre-faciales",
      age: labels["treatments.steamfacial.age"],
      title: labels["treatments.steamfacial.title"],
      description: labels["treatments.steamfacial.description"],
      price: labels["treatments.steamfacial.price"],
      aditional: [
        labels["treatments.steamfacial.aditional.1"],
        labels["treatments.steamfacial.aditional.2"],
        labels["treatments.steamfacial.aditional.3"],
        labels["treatments.steamfacial.aditional.4"],
        labels["treatments.steamfacial.aditional.5"],
      ],
      image: celulasmadrefaciales,
    },
    {
      slug: "nad-intravenoso",
      age: labels["treatments.nad.age"],
      title: labels["treatments.nad.title"],
      description: labels["treatments.nad.description"],
      price: labels["treatments.nad.price"],
      aditional: [
        labels["treatments.nad.aditional.1"],
        labels["treatments.nad.aditional.2"],
        labels["treatments.nad.aditional.3"],
        labels["treatments.nad.aditional.4"],
        labels["treatments.nad.aditional.5"],
      ],
      image: nadintravenoso2,
    }
  ];
}
